import { animate, inView, stagger } from "motion";

const settings = {
	duration: 2,
	delay: .3,
	selectors: [
		".fadein",
		".masthead",
		".footer",
		".hero",
		".floorplans",
		".snippet",
		".swiper",
		".map",
		// ".heading",
		".parallax",
		// ".moodboard img",
		// ".body",
		".amenities li",
		".featureboxes__item",
	],
};

const selector = settings.selectors.join(", ");

inView(selector, (event) => {
	animate(event.target, {
		opacity: [0, 1],
		// y: [-20, 0],
	}, {
		duration: settings.duration,
		delay: settings.delay,
	})
}, {
	margin: "0px 0px -100px 0px"
});
